<template>
  <div class="landing-banner" v-if="active">
    <div class="layout video-banner">
      <div :class="['ms-row collapsed', config.type == 'left' ? 'reverse' : '']">
        <div class="col-xs-12 col-md-8">
          <div class="video-holder">
            <VideoWrap :vSrc="config.nodes.video" :iSrc="config.nodes.src" :isAuto="true" :isLoop="false" :isMuted="true" />
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="text-holder">
            <div :class="['banner-title heading-h3','animated',config.type=='left'?'fadeInLeft':'fadeInRight','delay-500','go']" style="color: #fff;">{{config.nodes.title}}</div>
            <div :class="['heading-h2', 'animated', config.type=='left'?'fadeInLeft':'fadeInRight', 'delay-500', 'go']" style="color: #fff;" v-html="htmlify(config.nodes.desc)"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="['colored-box', config.type=='left'?'fadeInLeft':'fadeInRight','animated',  'delay-250','go']" :style="{backgroundColor: `${config.nodes.bgColor||'#52525E'}` }">&nbsp;</div>
  </div>
</template>

<script>
import VideoWrap from "@/components/VideoWrap";

export default {
  name: "InVideoAnimate",
  components: { VideoWrap },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return { active: false };
  },
  created() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.active = false;
      this.$nextTick(() => this.active = true);
    },
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    }
  },
  watch: {
    $route() {
      this.initPage();
    }
  }
};
</script>

<style lang="scss" scoped>
.landing-banner {
  position: relative; margin: 2.5rem 0 2.1875rem;
  .reverse {
    flex-direction: row-reverse; justify-content: center;
    .text-holder { margin: 0 5% 0 15%; }
  }
  .video-banner {
    z-index: 2;
    .video-holder {
      width: 85%;
      .video { width: 100%; height: auto; }
    }
  }

  .text-holder {
    padding: 2.1875rem 4.0625rem 3.4375rem 3.875rem;
    // .banner-title { font-size: 1.875rem; line-height: normal; }
    p { word-wrap: break-word; }
  }
  .fadeInRight.colored-box, .fadeInLeft.colored-box {
    width: 100%; position: absolute; bottom: 0; height: 80%; z-index: 1;
  }
  .fadeInRight.colored-box { right: 0; }
  .fadeInLeft.colored-box { left: 0; }
}
@media screen and (min-width: 48em) {
  .landing-banner {
    margin: 2.5rem 0 2.8125rem;
    .text-holder {
      padding: 3.4375rem 11.875rem 3.125rem 37%;
    }
    .fadeInRight.colored-box,
    .fadeInLeft.colored-box {
      width: 80%;
    }
  }
}

@media screen and (min-width: 64em) {
  .landing-banner {
    margin: 5rem 0 2.8125rem; padding: 0 1.875rem;
    .video-banner {
      .video-holder {
        width: 100%; margin: -2.5rem 0 2.5rem;
      }
    }
    .text-holder {
      // width: 30%;
      // margin: 0 15% 0 5%;
      // padding: 0;
      position: absolute; top: 50%; transform: translateY(-50%) translateY(-0.5px);
      padding: 3.125rem 2.0625rem 3.125rem 7%;
      // .banner-title {
      //   font-size: 3.125rem;
      // }
    }
    .fadeInRight.colored-box,
    .fadeInLeft.colored-box {
      height: 100%;
      width: 50%;
    }
    .fadeInRight {
      &.go { animation-name: fadeInRight; }
    }
    .fadeInLeft {
      &.go { animation-name: fadeInLeft; }
    }
  }
}
@media screen and (min-width: 75em) {
  .landing-banner {
    margin: 5.625rem 0 4.0625rem; padding: 0;
    .text-holder {
      // padding: 6.25rem 5.1875rem 6.25rem 7%;
    }
  }
}
</style>